(() => {
  class ScanwellResultsTableController {
    constructor(ngDialog, Utils, Orders, toastr) {
      Object.assign(this, {
        ngDialog,
        Utils,
        Orders,
        toastr
      });
      'ngInject';
      this.optionsPositive = [{
        id: '1',
        name: 'IgG+',
        value: 'IgG+'
      }, {
        id: '2',
        name: 'IgM+',
        value: 'IgM+'
      }, {
        id: '3',
        name: 'IgG+/IgM+',
        value: 'IgG+/IgM+'
      }];
      this.optionsNegative = [{
        id: '4',
        name: 'NEG IgG-/IgM-',
        value: 'IgG-/IgM-'
      }];
    }

    changeResultCode(result) {
      if (result.result_code && result.result_code == 'invalid') {
        result.result_code = null;
      } else {
        result.result_code = 'invalid';
      }
    }

    update(reviewed, result) {
      var this2 = this;
      const payload = {};

      if (reviewed && !result.result_code) {
        this.toastr.warning("Please choose one option for the lab result.");
        return;
      }

      if (reviewed) {
        payload.result_code = result.result_code;
        payload.defer = false;
      }

      if (!reviewed) {
        payload.defer = true;
      }

      this.Orders.updateScanwellResultsDetails(result.id, payload).then(() => {
        result.updated = true;
        this2.toastr.success("Lab result was updated successfully.");
      }).catch(err => {
        // THIS IS THE WAY TO DISPLAY ERRORS FOR GO ENDPOINTS
        if (err && err.data && err.data.error_message) {
          this2.toastr.error(err.data.error_message);
        } else {
          this2.toastr.error(this.Notifications.generic.failure);
        }
      });
    }

    requiresAction() {
      return false;
    }

    openPhotoGalleryScanwell(index = 0, image_uri) {
      this.photos = [];
      var photo = {
        file_id: 0,
        image_uri: image_uri
      };
      this.photos.push(photo);
      this.ngDialog.open({
        templateUrl: 'app/components/gallery/gallery.html',
        className: 'ngdialog-theme-default photo-dialog',
        controller: 'GalleryController',
        controllerAs: 'gallery',
        resolve: {
          files: () => this.photos,
          data: () => {
            return {
              index,
              requiresAction: this.requiresAction.bind(this)
            };
          }
        }
      });
    }

  }

  angular.module('pims').component('scanwellResultsTable', {
    templateUrl: 'app/components/scanwell-results-table/scanwell-results-table.html',
    controller: ScanwellResultsTableController,
    bindings: {
      pagination: '=',
      results: '<'
    }
  });
})();